import apiClient from "@/services/api-client";

export const billingControlService = {
  subscriptionChanges: async (status?: string) =>
    (await apiClient.get("/billing-control/subscription-changes", { params: { status } })).data,
  previewSubscriptionChange: async (subscriptionId: string, payload: Record<string, unknown>) =>
    (await apiClient.post(`/billing-control/subscriptions/${subscriptionId}/changes/preview`, payload)).data,
  scheduleSubscriptionChange: async (subscriptionId: string, payload: Record<string, unknown>) =>
    (await apiClient.post(`/billing-control/subscriptions/${subscriptionId}/changes`, payload)).data,
  reviewSubscriptionChange: async (id: string, decision: "APPROVE" | "REJECT", note: string) =>
    (await apiClient.post(`/billing-control/subscription-changes/${id}/review`, { decision, note })).data,
  cancelSubscriptionChange: async (id: string, reason: string) =>
    (await apiClient.post(`/billing-control/subscription-changes/${id}/cancel`, { reason })).data,
  refunds: async (status?: string) =>
    (await apiClient.get("/billing-control/refunds", { params: { status } })).data,
  requestRefund: async (paymentId: string, payload: { amount?: number; reason: string }) =>
    (await apiClient.post(`/billing-control/payments/${paymentId}/refund-approvals`, payload)).data,
  executeRefund: async (approvalId: string, reason: string) =>
    (await apiClient.post(`/billing-control/refund-approvals/${approvalId}/execute`, { reason })).data,
  ledger: async (tenantId?: string) =>
    (await apiClient.get("/billing-control/ledger", { params: { tenantId } })).data,
  dunningPolicies: async () => (await apiClient.get("/billing-control/dunning-policies")).data,
  createDunningPolicy: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/billing-control/dunning-policies", payload)).data,
  gateways: async () => (await apiClient.get("/billing-control/gateways")).data,
  createGateway: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/billing-control/gateways", payload)).data,
  webhookDeadLetters: async () => (await apiClient.get("/billing-control/webhooks/dead-letters")).data,
  requeueWebhook: async (id: string, reason: string) =>
    (await apiClient.post(`/billing-control/webhooks/${id}/requeue`, { reason })).data,
  reconciliation: async (status?: string) =>
    (await apiClient.get("/billing-control/reconciliation", { params: { status } })).data,
  resolveReconciliation: async (id: string, resolution: string, evidence?: Record<string, unknown>) =>
    (await apiClient.post(`/billing-control/reconciliation/${id}/resolve`, { resolution, evidence })).data,
};
